import Vue from "vue";
import VueRouter from "vue-router";

import Admin from "../views/Admin.vue";
import Home from "../views/Home.vue";
import { authGuard } from "../auth/authGuard";
import ImageOne from "../views/ImageOne.vue";
import Mobile from "../views/Mobile.vue";
import News from "../views/News.vue";
import Gallery from "../views/Gallery.vue";
import Login from "../views/login.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },

  {
    path: "/admin",
    name: "admin",
    component: Admin
  },

  {
    path: "/cancel",
    name: "cancel",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "payment" */ "@/views/Cancel.vue")
  },

  {
    path: "/ImageOne/:name",
    name: "ImageOne",
    component: ImageOne
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Gallery
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },

  {
    path: "/mobile",
    name: "mobile",
    component: Mobile
  },

  {
    path: "/news",
    name: "news",
    component: News
  },

  {
    path: "/pricing",
    name: "pricing",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "payment" */ "@/views/Pricing.vue")
  },

  {
    path: "/watch/robots/:id/",
    name: "watch-robot",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "watch-robot" */ "../views/WatchRobot.vue")
  },

  {
    path: "/control/robots/:id/:sessionID",
    name: "control-robot",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "control-robot" */ "../views/ControlRobot.vue"
      )
  },

  {
    path: "/robots",
    name: "robots",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "robots" */ "../views/Robots.vue")
  },

  {
    path: "/sessions/:id/:roverID",
    name: "session",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "session" */ "../views/Session.vue")
  },

  {
    path: "/success",
    name: "success",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "session" */ "../views/Success.vue")
  },

  {
    path: "/tutorial",
    name: "tutorial",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "tutorial" */ "../views/Tutorial.vue")
  },

  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login.vue")
  }

];

const router = new VueRouter({
  routes
});

export default router;
